/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * TODO — do zrobienia, DONE — dział skończył swoją część, NOT_APPLICABLE — nie dotyczy tej realizacji
 */

export const RealizationDepartmentStatusDto = {
    Todo: 'TODO',
    Done: 'DONE',
    NotApplicable: 'NOT_APPLICABLE',
} as const;

export type RealizationDepartmentStatusDto = typeof RealizationDepartmentStatusDto[keyof typeof RealizationDepartmentStatusDto];



